/* contacts: перевод строк интерфейса. Ключ — русская строка ровно как в коде. */
const d: Record<string, string> = {
  // --- окно «Контакты» (contactsapp.tsx) ---
  "Контакты": "Contacts",
  "Входящие": "Inbox",
  "Дашборд": "Dashboard",
  "Каналы": "Channels",
  "AI-агенты": "AI agents",
  "Рассылки": "Broadcasts",
  "Рабочие процессы": "Workflows",
  "Отчеты": "Reports",
  "Жизненный цикл": "Lifecycle",
  "Настройки": "Settings",
  "Общие сведения": "General",
  "Раздел «{label}» пока не открывается": "The “{label}” section is not available yet",
  "Контакт «{name}» добавлен в базу — этап «{stage}»": "Contact “{name}” added — stage “{stage}”",
  "Контакт «{name}» добавлен в базу": "Contact “{name}” added",
  "Контакт «{name}» обновлён": "Contact “{name}” updated",
  "Контакт «{name}» удалён": "Contact “{name}” deleted",
  "AI-агент настраивается в разделе AI Assist — открыли его для вас": "The AI agent is set up in AI Assist — we opened it for you",
  "Все контакты": "All contacts",
  "/ рабочее пространство → контакты": "/ workspace → contacts",
  "Контактов: {n}": "Contacts: {n}",
  "Поиск по контактам": "Search contacts",
  "Добавить контакт": "Add contact",
  "Создать AI-агента": "Create AI agent",
  "Потерянные этапы": "Lost stages",
  "Сегменты": "Segments",
  "видны только ваши контакты": "only your contacts are visible",
  "Поиск контактов": "Search contacts",
  "Очистить поиск": "Clear search",
  "Импорт контактов": "Import contacts",
  "Импорт": "Import",
  "Все": "All",
  "· поиск: «{q}»": "· search: “{q}”",
  "из импорта «{file}»": "from import “{file}”",
  "Показать все контакты": "Show all contacts",
  "Загружаем контакты…": "Loading contacts…",
  "Здесь пока пусто": "Nothing here yet",
  "По запросу «{q}» никого не нашли — попробуйте другое имя, телефон или почту.": "No one matches “{q}” — try another name, phone or email.",
  "В папке «{folder}» нет контактов. Выберите другую папку.": "No contacts in “{folder}”. Pick another folder.",
  "Заблокирован": "Blocked",
  "нет контактов": "no contact details",
  "Загружаем…": "Loading…",
  "Показать ещё ({n})": "Show more ({n})",
  "Открыть «{label}»": "Open “{label}”",

  // --- панель контакта (contactsapp-panel.tsx) ---
  "Другой пользователь": "Another user",
  "Закрыть панель": "Close panel",
  "Новый контакт": "New contact",
  "Контакт": "Contact",
  "Данные контакта": "Contact details",
  "Владелец контакта": "Contact owner",
  "Вы": "You",
  "Имя": "First name",
  "Введите имя": "Enter first name",
  "Имя обязательно — без него контакт не создать": "First name is required to create a contact",
  "Фамилия": "Last name",
  "Введите фамилию": "Enter last name",
  "Телефон": "Phone",
  "Код страны": "Country code",
  "Номер телефона": "Phone number",
  "Клиент": "Customer",
  "долг {sum}": "due {sum}",
  "Другие каналы": "Other channels",
  "Доп. телефон": "Extra phone",
  "Электронная почта": "Email",
  "Введите адрес почты": "Enter email address",
  "Компания": "Company",
  "Название компании": "Company name",
  "Добавить этап жизненного цикла": "Add lifecycle stage",
  "Сбросить этап": "Clear stage",
  "Этапы жизненного цикла": "Lifecycle stages",
  "Теги": "Tags",
  "· видно только администраторам": "· visible to admins only",
  "Например: {list}": "For example: {list}",
  "Значения через ;": "Values separated by ;",
  // подписи полей, которые приходят из базы (сид 0003_contacts_seed.sql, импорт CSV)
  "Внутренняя заметка": "Internal note",
  "Видна только администраторам": "Visible to admins only",
  "Из импорта": "From import",
  "Должность": "Job title",
  "Контакт появится в базе рабочего пространства. Этап можно не выбирать — новый лид получит этап по умолчанию из настроек жизненного цикла.":
    "The contact will be added to the workspace database. The stage is optional — a new lead gets the default stage from the lifecycle settings.",
  "Точно удалить?": "Delete for sure?",
  "Удалить": "Delete",
  "Отмена": "Cancel",
  "Сохраняем…": "Saving…",
  "Создать": "Create",
  "Сохранить": "Save",

  // --- contactsapp-meta.ts ---
  "Созданы < 7 дней": "Created < 7 days ago",
  "Контакты, которых добавили на этой неделе": "Contacts added this week",
  "Неактивны > 3 месяцев": "Inactive > 3 months",
  "Нет сообщений и звонков больше трёх месяцев": "No messages or calls for more than three months",
  "С тегами": "Tagged",
  "У контакта есть хотя бы один тег": "The contact has at least one tag",
  "Страна известна": "Country known",
  "Заполнено поле «Страна»": "The “Country” field is filled in",
  "Язык известен": "Language known",
  "Определён язык переписки": "The conversation language is detected",
  "Заблокированные": "Blocked",
  "Контакты, которым запрещено писать": "Contacts that cannot be messaged",
  "Италия": "Italy",
  "Россия": "Russia",
  "Казахстан": "Kazakhstan",
  "Беларусь": "Belarus",
  "Германия": "Germany",
  "Испания": "Spain",
  "США": "USA",
  "Турция": "Turkey",
  "ОАЭ": "UAE",
  "Саудовская Аравия": "Saudi Arabia",
  "Катар": "Qatar",
  "Оман": "Oman",
  "Кувейт": "Kuwait",
  "Бахрейн": "Bahrain",
  "Великобритания": "United Kingdom",
  "Индия": "India",
  "Пакистан": "Pakistan",
  "Египет": "Egypt",
  "Франция": "France",
  "Китай": "China",
  "В этом рабочем пространстве нет контактов": "This workspace has no contacts",
  "Добавьте один контакт или загрузите CSV-файл, чтобы импортировать несколько контактов сразу.": "Add a single contact or upload a CSV file to import several contacts at once.",
  "Контакты — общая база": "Contacts — a shared database",
  "Один клиент — одна карточка, даже если он писал в WhatsApp, Telegram и на почту.": "One customer — one card, even if they wrote on WhatsApp, Telegram and email.",
  "Папки вместо фильтров": "Folders instead of filters",
  "Этапы жизненного цикла и сегменты сразу считают, сколько контактов подходит под условие.": "Lifecycle stages and segments instantly count how many contacts match.",
  "Импорт и экспорт": "Import and export",
  "CSV-файл загружается в браузере, а выгрузку можно запросить в «Экспорте данных».": "A CSV file is uploaded in the browser, and an export can be requested in “Data export”.",
  "только что": "just now",
  "{n} мин назад": "{n} min ago",
  "{n} ч назад": "{n} h ago",
  "Вчера": "Yesterday",
  "{d} назад": "{d} ago",
  "дней": "day|days",

  // --- contacts-api.ts: причины пропуска строк импорта ---
  "пустая строка: нет имени, телефона и почты": "empty row: no name, phone or email",
  "телефон в неверном формате": "invalid phone format",
  "почта в неверном формате": "invalid email format",
  "в числовом поле не число": "numeric field is not a number",
  "телефон уже есть у другого контакта": "phone already belongs to another contact",
  "почта уже есть у другого контакта": "email already belongs to another contact",

  // --- companies.tsx / companies-api.ts ---
  "Название, TRN, почта или домен": "Name, TRN, email or domain",
  "Поиск компаний": "Search companies",
  "Только мои": "Mine only",
  "Название новой компании": "New company name",
  "{n} компаний": "{n} companies",
  "Загрузка…": "Loading…",
  "сортировка: {col}, {dir}": "sorted by {col}, {dir}",
  "по убыванию": "descending",
  "по возрастанию": "ascending",
  "Сортировать по колонке «{col}»; повторный клик меняет направление": "Sort by \"{col}\"; click again to flip the direction",
  "Страна": "Country",
  "Сегмент": "Segment",
  "Люди": "People",
  "Выручка": "Revenue",
  "Долг": "Due",
  "Последний счёт": "Last invoice",
  "Компаний не найдено. Они появятся после синхронизации с Zoho (раздел «Zoho»).": "No companies found. They will appear after syncing with Zoho (the “Zoho” section).",
  "Название": "Name",
  "Почта": "Email",
  "Город": "City",
  "Сайт": "Website",
  "Адрес": "Address",
  "Заметки": "Notes",
  "Карточка компании сохранена": "Company card saved",
  "Все компании": "All companies",
  "из Zoho CRM": "from Zoho CRM",
  "заведена в Hub": "created in Hub",
  "Выручка (счета Books)": "Revenue (Books invoices)",
  "Долг сейчас": "Currently due",
  "нет": "none",
  "Люди компании": "Company people",
  "Люди ({n})": "People ({n})",
  "Переписка и история остаются у человека — компания собирает всех, кто пишет от её имени.": "Conversations and history stay with the person — the company gathers everyone who writes on its behalf.",
  "Роль сохранена": "Role saved",
  "Роль: {name}": "Role: {name}",
  "Роль не указана": "No role",
  "{name} больше не в компании": "{name} is no longer in the company",
  "Убрать {name} из компании": "Remove {name} from the company",
  "Пока никого — добавьте человека из контактов.": "Nobody yet — add a person from contacts.",
  "Ещё {n} — у других продавцов.": "{n} more belong to other salespeople.",
  "Добавить человека: имя, телефон или почта": "Add a person: name, phone or email",
  "Найти контакт": "Find contact",
  "{name} добавлен в компанию": "{name} added to the company",
  "Клиенты в Zoho Books ({n})": "Zoho Books customers ({n})",
  "{n} счетов": "{n} invoices",
  "связь: {why}": "link: {why}",
  "Не связана с Books. Связать можно в разделе «Zoho» → сопоставление.": "Not linked to Books. Link it in the “Zoho” section → matching.",
  "Реквизиты": "Details",
  "Сохраняю…": "Saving…",
  "Закупщик": "Buyer",
  "Владелец": "Owner",
  "Бухгалтерия": "Accounting",
  "Руководитель": "Manager",
  "Другое": "Other",

  // --- zohomatch.tsx ---
  "Нужно связать": "To link",
  "Компания без человека": "Company without a person",
  "Связаны": "Linked",
  "Не связано": "Not linked",
  "Синхронизация запущена — по окончании придёт уведомление": "Sync started — you will be notified when it finishes",
  "Zoho CRM и Books → Hub": "Zoho CRM and Books → Hub",
  "Zoho не подключён: нужны ключи в настройках сервера.": "Zoho is not connected: keys are required in the server settings.",
  "Только чтение · автоматически каждые {min} мин · последняя удачная: {when}": "Read-only · automatically every {min} min · last successful: {when}",
  "идёт синхронизация…": "syncing…",
  "Ошибка последнего запуска: {error}": "Last run error: {error}",
  "Синхронизировать сейчас": "Sync now",
  "Импорт истории Wazzup запущен — по окончании придёт уведомление": "Wazzup history import started — you will be notified when it finishes",
  "История переписки Wazzup": "Wazzup chat history",
  "{m} сообщений в {d} диалогах, новых контактов {c} · последний импорт: {when}": "{m} messages in {d} conversations, {c} new contacts · last import: {when}",
  "Журнал Wazzup из Zoho CRM (около 125 тыс. сообщений с июня 2024) ещё не импортирован.": "The Wazzup log from Zoho CRM (about 125k messages since June 2024) has not been imported yet.",
  "идёт импорт…": "importing…",
  "({n} сообщений)": "({n} messages)",
  "Диалоги попадают в «Закрытые» во «Входящих» и привязываются к контактам по номеру; после первого импорта новые записи докачиваются вместе с синхронизацией.": "Conversations land in “Closed” in the Inbox and are linked to contacts by phone number; after the first import, new records are fetched together with the sync.",
  "Докачать новые": "Fetch new",
  "Импортировать историю": "Import history",
  "Привязать архив к компаниям": "Link archive to companies",
  "Слить дубли по телефону": "Merge duplicates by phone",
  "Дубли": "Duplicates",
  "Вероятные дубли: компании с одним названием (без правовой формы) или одним TRN. Отметьте, какая карточка остаётся, снимите галочки с тех, что не дубли, и нажмите «Слить» — люди, сделки, заметки, задачи и клиенты Books перейдут к оставшейся, остальные карточки будут удалены. Аккаунты Zoho CRM удалённых карточек запоминаются, и синхронизация не создаст их заново.":
    "Probable duplicates: companies with the same name (ignoring the legal form) or the same TRN. Choose the card that stays, untick the ones that are not duplicates and click “Merge” — people, deals, notes, tasks and Books customers move to the remaining card, the others are deleted. Zoho CRM accounts of the deleted cards are remembered, so the sync will not recreate them.",
  "Дублей не найдено": "No duplicates found",
  "{n} групп": "{n} groups",
  "Оставить": "Keep",
  "Слить": "Merge",
  "одно название": "same name",
  "один TRN": "same TRN",
  "Подтвердить: удалить {n} и оставить «{name}»": "Confirm: delete {n} and keep “{name}”",
  "Слить {n} в «{name}»": "Merge {n} into “{name}”",
  "Слито: {n} → «{name}»": "Merged: {n} → “{name}”",
  "Мои клиенты": "My clients",
  "Без ответственного": "No owner",
  "Чьи компании": "Whose companies",
  "Это мой клиент": "This is my client",
  "— без ответственного —": "— no owner —",
  "не назначен": "not assigned",
  "вы": "you",
  "история": "history",
  "скрыть историю": "hide history",
  "никто": "nobody",
  "Ответственный ещё не менялся.": "The owner has not changed yet.",
  "У вас пока нет своих компаний. Откройте «Без ответственного» или «Все» и нажмите в карточке «Это мой клиент».": "You have no companies yet. Open \"No owner\" or \"All\" and click \"This is my client\" in a card.",
  "Сбросить": "Reset",
  "Слияние дублей запущено — по окончании придёт уведомление": "Duplicate merge has started — you will get a notification when it finishes",
  "Контакт CRM без номера и контакт переписки с номером клиента Books — один человек: остаётся контакт CRM, к нему переходят диалоги, сделки и финансы": "A CRM contact without a number and a chat contact with the Books customer's number are the same person: the CRM contact stays and gets the dialogs, deals and finance",
  "Привязка архива к компаниям запущена — диалоги появятся в карточках через несколько минут": "Linking the archive to companies has started — dialogs will show up in company cards in a few minutes",
  "Диалоги архива → сделка CRM → компания и контакт: WhatsApp-переписка попадает в карточку компании": "Archive dialogs → CRM deal → company and contact: WhatsApp history lands in the company card",
  "Компаний в Hub": "Companies in Hub",
  "клиентов Books: {n}": "Books customers: {n}",
  "Покупатели связаны": "Buyers linked",
  "{a} из {b}": "{a} of {b}",
  "Есть подсказка": "Suggested",
  "Без кандидата": "No candidate",
  "Сами связываются: компания или контакт Zoho CRM, совпавший телефон (включая WhatsApp) или почта. Подсказки — по домену корпоративной почты, TRN и названию. Карточки клиентов Books дочитываются постепенно (дневной лимит Zoho), поэтому часть подсказок превратится в связи сама.":
    "Linked automatically: a Zoho CRM company or contact, a matching phone (including WhatsApp) or email. Suggestions come from the corporate email domain, TRN and name. Books customer cards are fetched gradually (Zoho daily limit), so some suggestions will turn into links on their own.",
  "Клиент, почта, TRN": "Customer, email, TRN",
  "Поиск клиента Books": "Search Books customer",
  "{n} покупателей · по выручке": "{n} buyers · by revenue",
  "Связь пересчитана по правилам": "Link recalculated by the rules",
  "Пересчитать": "Recalculate",
  "Выбрать компанию": "Choose company",
  "Отмечено: не связано": "Marked as not linked",
  "Связано с «{name}»": "Linked to “{name}”",
  "Связать": "Link",
  "Здесь пусто.": "Nothing here.",
  "Найти компанию": "Find company",
  "{n} чел.": "{n} people",
  "Не найдено — создайте компанию в разделе «Компании».": "Not found — create the company in the “Companies” section.",

  // --- import.tsx / import-result.tsx ---
  "В очереди": "Queued",
  "Загружается": "Uploading",
  "Завершено": "Completed",
  "Не выполнен": "Failed",
  "Импорт «{file}» завершён: добавлено {added}, обновлено {updated}": "Import “{file}” completed: {added} added, {updated} updated",
  "Импорт «{file}» не выполнен — подробности в уведомлении": "Import “{file}” failed — see the notification for details",
  "Файл «{file}» загружается в фоне — по окончании придёт уведомление": "File “{file}” is being imported in the background — you will be notified when it finishes",
  "/ настройки данных → импорт контактов": "/ data settings → import contacts",
  "Импортов: {n}": "Imports: {n}",
  "Доступы": "Access",
  "Импорт контактов доступен владельцу, администраторам и менеджерам. Агенты работают только со своими контактами.": "Contact import is available to the owner, admins and managers. Agents work only with their own contacts.",
  "Просмотрите прошлые импорты или начните новый.": "Review past imports or start a new one.",
  "Скачать шаблон": "Download template",
  "Импорт доступен владельцу, администраторам и менеджерам": "Import is available to the owner, admins and managers",
  "Импорт недоступен для вашей роли": "Import is not available for your role",
  "Загрузить контакты из файла могут владелец, администраторы и менеджеры — попросите их, если нужно.": "The owner, admins and managers can upload contacts from a file — ask them if you need it.",
  "Загружаем историю…": "Loading history…",
  "Импортируйте первый контакт": "Import your first contacts",
  "Импорт контактов нужен для массовой загрузки нескольких контактов на платформу.": "Contact import is for bulk-loading many contacts into the platform.",
  "Файл": "File",
  "Пропущено": "Skipped",
  "Автор": "Author",
  "Дата": "Date",
  "Открыть результат импорта": "Open import result",
  "из {n}": "of {n}",
  "Строка {line}: {text}": "Row {line}: {text}",
  "Пока пусто — контакты добавляются вручную или через каналы": "Nothing yet — contacts are added manually or via channels",
  "{n} · последний {date}": "{n} · latest {date}",
  "Загрузка идёт в фоне — придёт уведомление": "Import runs in the background — you will be notified",
  "Нажмите на импорт, чтобы увидеть результат: сколько создано и обновлено, пропущенные строки с причиной и загруженные контакты. В истории — последние 50 импортов.":
    "Click an import to see its result: how many were created and updated, skipped rows with the reason, and the imported contacts. The history keeps the last 50 imports.",
  "контактов": "contact|contacts",
  "импортов": "import|imports",
  "Создано": "Created",
  "Обновлено": "Updated",
  "Все импорты": "All imports",
  "начат {when}": "started {when}",
  "закончен {when}": "finished {when}",
  "Открыть контакты импорта": "Open imported contacts",
  "«Обновлено» — контакты, которые уже были в базе или повторялись в файле (совпали по ID, почте или телефону): их дополнили данными из строки, дубли не создавались.":
    "“Updated” — contacts that were already in the database or repeated in the file (matched by ID, email or phone): they were enriched with the row data, no duplicates were created.",
  "Импорт не выполнен: {error}. Попробуйте загрузить файл ещё раз или напишите в «Идея / проблема».": "Import failed: {error}. Try uploading the file again or write to “Idea / issue”.",
  "неизвестная ошибка": "unknown error",
  "Пропущенные строки": "Skipped rows",
  "Скачать пропущенные строки": "Download skipped rows",
  "Как исправить: скачайте файл — в нём только эти строки и колонка «Ошибка» с причиной. Поправьте значения в Excel, сохраните как CSV и загрузите через «Импорт контактов»: исправленные строки добавятся, уже загруженные контакты не задвоятся. Одну-две строки проще добавить вручную в разделе «Контакты» → «Добавить контакт».":
    "How to fix: download the file — it contains only these rows plus an “Error” column with the reason. Correct the values in Excel, save as CSV and upload via “Import contacts”: the fixed rows will be added and already imported contacts will not be duplicated. One or two rows are easier to add manually in “Contacts” → “Add contact”.",
  "Строка файла": "File row",
  "Причина": "Reason",
  "Значение": "Value",
  "Показаны первые {shown} из {total} — остальные с той же причиной, исправьте показанные и загрузите файл снова.": "Showing the first {shown} of {total} — the rest have the same reason; fix the ones shown and upload the file again.",
  "Все строки загружены без ошибок.": "All rows imported without errors.",

  // --- importwizard.tsx / import-meta.ts ---
  "+971 ОАЭ": "+971 UAE",
  "+966 Саудовская Аравия": "+966 Saudi Arabia",
  "+974 Катар": "+974 Qatar",
  "+968 Оман": "+968 Oman",
  "+7 Россия / Казахстан": "+7 Russia / Kazakhstan",
  "+39 Италия": "+39 Italy",
  "+44 Великобритания": "+44 United Kingdom",
  "+91 Индия": "+91 India",
  "Не добавлять код": "Do not add a code",
  "Нужен файл в формате CSV — выгрузите его из CRM или таблицы": "A CSV file is required — export it from your CRM or spreadsheet",
  "Файл больше 20 МБ — разделите выгрузку на части": "The file is over 20 MB — split the export into parts",
  "В файле нет строк с данными — только заголовки": "The file has no data rows — only headers",
  "Сначала выберите CSV-файл — без него сопоставлять нечего": "Choose a CSV file first — there is nothing to map without it",
  "Сопоставьте хотя бы одну колонку с именем, телефоном или email": "Map at least one column to name, phone or email",
  "Одно и то же поле выбрано для двух колонок — оставьте по одной колонке на поле": "The same field is selected for two columns — keep one column per field",
  "Назад": "Back",
  "Загрузите CSV-файл, чтобы добавить или обновить контакты.": "Upload a CSV file to add or update contacts.",
  "Заполните шаблон: в нём все поля карточки и два примера строк — колонки сопоставятся сами.": "Fill in the template: it has all card fields and two sample rows — columns will be mapped automatically.",
  "Выбрать CSV-файл": "Choose CSV file",
  "Читаем файл…": "Reading file…",
  "{n} строк": "{n} rows",
  "Инструкции:": "Instructions:",
  "Сопоставьте колонки файла с полями контакта. Мы подставили похожие названия автоматически — проверьте их.": "Map the file columns to contact fields. We matched similar names automatically — please check them.",
  "Распознали выгрузку Zoho CRM. Основным телефоном станет WhatsApp или мобильный, остальные номера сохранятся в карточке как дополнительные. Страна берётся из Country2 или Mailing Country, ответственный — из Sales Person по имени или почте пользователя Hub. «Новое поле» создаст в карточке поле с названием колонки. Повторный импорт той же выгрузки обновит контакты по Record Id, а не создаст дубли.":
    "Zoho CRM export detected. WhatsApp or mobile becomes the primary phone; other numbers are saved in the card as extra ones. Country comes from Country2 or Mailing Country, the assignee from Sales Person by the Hub user's name or email. “New field” creates a card field named after the column. Re-importing the same export updates contacts by Record Id instead of creating duplicates.",
  "Номера без кода страны (056…, 050…):": "Numbers without a country code (056…, 050…):",
  "Колонка в файле": "File column",
  "Пример": "Sample",
  "Поле контакта": "Contact field",
  "Без названия": "Untitled",
  "Поле для колонки {h}": "Field for column {h}",
  "Первая строка после сопоставления": "First row after mapping",
  "Проверьте итог перед загрузкой: найденные по ID, email или телефону контакты обновятся, новые добавятся, строки с ошибками будут пропущены.": "Review the summary before importing: contacts matched by ID, email or phone will be updated, new ones added, rows with errors skipped.",
  "Строк в файле": "Rows in file",
  "Добавим контактов": "Contacts to add",
  "Обновим": "To update",
  "Пропустим": "To skip",
  "Проверены первые {n} строк — итог по всему файлу будет в истории.": "The first {n} rows were checked — the full-file result will be in the history.",
  "Не нашли пользователей Hub: {list}. Эти контакты достанутся вам — заведите пользователей с такими именами (Настройки → Пользователи) и повторите импорт, если нужно иначе.":
    "Hub users not found: {list}. These contacts will be assigned to you — add users with these names (Settings → Users) and repeat the import if you need otherwise.",
  "Не распознали страну: {list} — поле «Страна» останется пустым.": "Country not recognised: {list} — the “Country” field will stay empty.",
  "Строка {n}": "Row {n}",
  "Ошибок в проверенных строках нет": "No errors in the checked rows",
  "И ещё {n} строк с ошибками.": "And {n} more rows with errors.",
  "Загрузка идёт в фоне — по окончании придёт уведомление.": "Import runs in the background — you will be notified when it finishes.",
  "Импортировать контакты": "Import contacts",
  "Проверяем…": "Checking…",
  "Далее": "Next",
  "Загрузка CSV-файла": "Upload CSV file",
  "Сопоставление": "Mapping",
  "Проверка": "Review",
  "Проще всего заполнить шаблон («Скачать шаблон») — колонки сопоставятся сами. Подойдёт и выгрузка из Zoho CRM или другой CRM.": "The easiest way is to fill in the template (“Download template”) — columns will be mapped automatically. An export from Zoho CRM or another CRM works too.",
  "Существующие контакты ищутся по колонке ID контакта, затем по email, затем по телефону — найденные обновятся, остальные добавятся.": "Existing contacts are matched by the Contact ID column, then by email, then by phone — matches are updated, the rest are added.",
  "Размер файла не должен превышать 20 МБ.": "The file must not exceed 20 MB.",
  "В файле должно быть меньше 200 000 строк.": "The file must have fewer than 200,000 rows.",
  "У всех колонок должны быть заголовки, иначе их не удастся сопоставить.": "All columns must have headers, otherwise they cannot be mapped.",
  "Кодировка UTF-8 или Windows-1251, разделитель — запятая, точка с запятой или табуляция: определяются сами.": "UTF-8 or Windows-1251 encoding; comma, semicolon or tab delimiter — detected automatically.",

  // --- dataexport.tsx / dataexport-meta.ts ---
  "Обработка": "Processing",
  "Готово": "Done",
  "Ошибка": "Error",
  "обновлено только что": "refreshed just now",
  "Один экспорт уже готовится — дождитесь его окончания": "An export is already being prepared — wait for it to finish",
  "Выгрузка «{name}» {note}": "Export “{name}” {note}",
  "Запрос на выгрузку «{name}» создан — когда файл будет готов, придёт уведомление": "Export request “{name}” created — you will be notified when the file is ready",
  "Файл «{name}» скачивается — {rows}": "Downloading “{name}” — {rows}",
  "Выгрузка ещё готовится — статус обновится автоматически": "The export is still being prepared — the status will update automatically",
  "/ настройки данных → экспорт данных": "/ data settings → data export",
  "Запросов: {n}": "Requests: {n}",
  "Выгрузку запрашивают владелец, администраторы и сотрудники с правом «Экспорт данных». Файл доступен 24 часа, затем удаляется.": "Exports can be requested by the owner, admins and staff with the “Data export” permission. The file is available for 24 hours, then deleted.",
  "Экспорт данных": "Data export",
  "Экспорт записей рабочего пространства для аналитики и других целей.": "Export workspace records for analytics and other purposes.",
  "Выберите данные для экспорта": "Choose data to export",
  "Что экспортировать": "What to export",
  "После запроса данные подготовятся, а мы сообщим, когда файл будет готов к скачиванию. В выгрузку попадают все контакты, которые видны вам. Пока одна выгрузка готовится, новую запросить нельзя.":
    "After the request the data is prepared and we will let you know when the file is ready to download. The export includes all contacts visible to you. While one export is being prepared, a new one cannot be requested.",
  "Выгрузка доступна владельцу, администраторам и сотрудникам с правом «Экспорт данных».": "Export is available to the owner, admins and staff with the “Data export” permission.",
  "Экспортируйте первые данные": "Export your first data",
  "Экспорт данных позволяет выгружать контакты в CSV для аналитики в таблицах и BI. Диалоги и сообщения {note}.": "Data export lets you download contacts as CSV for analytics in spreadsheets and BI. Conversations and messages {note}.",
  "История экспорта данных": "Data export history",
  "Обновить": "Refresh",
  "Дата запроса": "Requested",
  "Набор данных": "Dataset",
  "Доступен до": "Available until",
  "Статус": "Status",
  "Данные": "Data",
  "выгрузка не удалась": "export failed",
  "готовится…": "preparing…",
  "истёк": "expired",
  "Истёк": "Expired",
  "Файл хранится 24 часа — запросите выгрузку заново": "The file is kept for 24 hours — request the export again",
  "Скачать": "Download",
  "Файл хранится 24 часа": "The file is kept for 24 hours",
  "{n} · показаны последние 50": "{n} · showing the last 50",
  "строк": "row|rows",
  "запросов": "request|requests",
  "Карточки клиентов: имена, телефоны, почта, компании, этапы, теги и свои поля": "Customer cards: names, phones, email, companies, stages, tags and custom fields",
  "Диалоги": "Conversations",
  "Каналы, ответственные продавцы, статус и время ответа": "Channels, assigned salespeople, status and response time",
  "Сообщения": "Messages",
  "Тексты, вложения, автор и время отправки по каждому диалогу": "Texts, attachments, author and send time for every conversation",
  "Неудавшиеся сообщения": "Failed messages",
  "Что не доставилось: канал, причина ошибки и повторная отправка": "What was not delivered: channel, error reason and resend",
  "появится с подключением каналов (этап 3)": "will be available once channels are connected (stage 3)",

  // --- lifecycle.tsx ---
  "Этап {n}": "Stage {n}",
  "Потерянный этап {n}": "Lost stage {n}",
  "Этап «{name}» добавлен — задайте название и иконку, затем нажмите «Сохранить»": "Stage “{name}” added — set a name and icon, then click “Save”",
  "После сохранения новые контакты будут попадать на этап «{name}»": "After saving, new contacts will go to the “{name}” stage",
  "Этап «{name}» больше не считается выигранным": "Stage “{name}” is no longer counted as won",
  "Этап «{name}» помечен как выигранный": "Stage “{name}” marked as won",
  "Этап по умолчанию нельзя перенести в потерянные — сначала назначьте другой этап по умолчанию": "The default stage cannot be moved to lost — set another default stage first",
  "Этап «{name}» перенесён в потерянные": "Stage “{name}” moved to lost",
  "Этап «{name}» возвращён в воронку": "Stage “{name}” returned to the pipeline",
  "Этап по умолчанию удалить нельзя — сначала назначьте другой этап по умолчанию": "The default stage cannot be deleted — set another default stage first",
  "Последний этап удалить нельзя — в воронке должен остаться хотя бы один": "The last stage cannot be deleted — the pipeline needs at least one",
  "Этап «{name}» удалён — после сохранения {contacts} перейдут на этап «{def}»": "Stage “{name}” deleted — after saving, {contacts} will move to the “{def}” stage",
  "Этап «{name}» удалён — нажмите «Сохранить», чтобы применить": "Stage “{name}” deleted — click “Save” to apply",
  "У каждого этапа должно быть название": "Every stage needs a name",
  "Два этапа называются «{name}» — переименуйте один из них": "Two stages are named “{name}” — rename one of them",
  "Этапы сохранены — воронка контактов уже использует новый порядок": "Stages saved — the contact pipeline already uses the new order",
  "Изменения отменены — этапы вернулись к сохранённому виду": "Changes discarded — stages reverted to the saved state",
  "Раздел «{label}» пока не подключён": "The “{label}” section is not connected yet",
  "Сменить иконку": "Change icon",
  "Сделать по умолчанию": "Make default",
  "Снять отметку «выигран»": "Unmark as won",
  "Пометить как выигранный": "Mark as won",
  "В потерянные этапы": "Move to lost stages",
  "Вернуть в воронку": "Return to pipeline",
  "Удалить этап": "Delete stage",
  "Название этапа {n}": "Stage {n} name",
  "Этап по умолчанию": "Default stage",
  "Выигран": "Won",
  "Действия с этапом {name}": "Actions for stage {name}",
  "Скрыть описание": "Hide description",
  "Показать описание": "Show description",
  "Описание этапа {name}": "Description of stage {name}",
  "Что происходит с контактом на этом этапе": "What happens to a contact at this stage",
  "/ настройки → входящие → жизненный цикл": "/ settings → inbox → lifecycle",
  "Этапов: {n}": "Stages: {n}",
  "Загружаем этапы…": "Loading stages…",
  "Менять этапы могут владелец и администраторы. Остальные сотрудники переводят контакты между этапами.": "The owner and admins can edit stages. Other staff move contacts between stages.",
  "Отслеживайте, на каком этапе продаж находится каждый контакт.": "Track which sales stage each contact is at.",
  "Новые контакты попадают на этап по умолчанию. «Выигран» и потерянные этапы считаются в отчётах воронки.": "New contacts go to the default stage. “Won” and lost stages are counted in pipeline reports.",
  "Узнать больше": "Learn more",
  "Показывать этапы жизненного цикла": "Show lifecycle stages",
  "Этапы видны во входящих и в карточке контакта. Если скрыть, данные контактов останутся прежними — пропадёт только отображение.": "Stages are shown in the inbox and on the contact card. Hiding them keeps contact data intact — only the display disappears.",
  "Этапы скрыты на этом экране — контакты и данные не изменились": "Stages hidden on this screen — contacts and data are unchanged",
  "Этапы снова видны": "Stages are visible again",
  "Настроить этапы воронки": "Configure pipeline stages",
  "Ведите контакты по этапам продаж. Этап по умолчанию назначается новым контактам автоматически.": "Move contacts through the sales stages. The default stage is assigned to new contacts automatically.",
  "Добавить этап": "Add stage",
  "Сюда попадают контакты, вышедшие из процесса продаж. Отдельный ящик для них не создаётся.": "Contacts that left the sales process end up here. No separate inbox is created for them.",
  "Этапы скрыты": "Stages hidden",
  "Воронка скрыта на этом экране. Включите тумблер выше, чтобы вернуть этапы и настроить их.": "The pipeline is hidden on this screen. Turn on the switch above to bring the stages back and configure them.",
  "Изменения применяются после «Сохранить». Контакты удалённого этапа переходят на этап по умолчанию.": "Changes apply after “Save”. Contacts of a deleted stage move to the default stage.",
  "У вас только просмотр: этапы меняют владелец и администраторы.": "You have view-only access: the owner and admins edit stages.",
  "+971 50 123 4567 или @nick": "+971 50 123 4567 or @nick",
  "Распределение запущено — по окончании придёт уведомление": "Distribution started — you will be notified when it finishes",
  "{name}: назначено диалогов — {n}": "{name}: conversations assigned — {n}",
  "{name}: привязка сохранена": "{name}: link saved",
  "Продавцы Zoho (Sales Person)": "Zoho salespersons (Sales Person)",
  "Диалоги архива Wazzup и клиенты распределяются по полю Sales Person: сделка из журнала Wazzup → контакт CRM → клиент Books. Привяжите продавца к сотруднику Hub — его диалоги без ответственного перейдут к нему вместе с клиентами.": "Wazzup archive conversations and customers are distributed by the Sales Person field: deal from the Wazzup log → CRM contact → Books customer. Link a salesperson to a Hub user and their unassigned conversations move to that user together with the customers.",
  "Последний запуск: {when} — продавец определён у {n} диалогов, назначено {m}.": "Last run: {when} — salesperson resolved for {n} conversations, {m} assigned.",
  "Без продавца: {n} диалогов.": "Without a salesperson: {n} conversations.",
  "идёт распределение…": "distributing…",
  "Распределить снова": "Distribute again",
  "Распределить диалоги": "Distribute conversations",
  "неактивен": "inactive",
  "почта не указана": "no e-mail",
  "сделок: {n}": "deals: {n}",
  "диалогов: {n}": "conversations: {n}",
  "без ответственного: {n}": "unassigned: {n}",
  "Сотрудник Hub для {name}": "Hub user for {name}",
  "— не привязан —": "— not linked —",
  "почта сотрудника": "user e-mail",
  "Почта для нового сотрудника {name}": "E-mail for the new user {name}",
  "Завести агента": "Create agent",
  "не привязан": "not linked",
  "Снять тег «{name}»": "Remove tag “{name}”",
  "Добавить тег": "Add tag",
  "Тегов нет": "No tags",
  "Найти тег…": "Find a tag…",
  "Найти тег": "Find a tag",
  "Все теги уже выбраны.": "All tags are already selected.",
  "Ничего не найдено — новые теги заводятся в окне «Теги».": "Nothing found — new tags are created in the “Tags” window.",
  "— не выбрано —": "— not set —",
  "Группа «{name}»": "Group “{name}”",
  "Группа «{name}» обновлена": "Group “{name}” updated",
  "Группа «{name}» создана: {n}. В карточке контакта она выбирается из списка": "Group “{name}” created: {n}. In the contact card it is picked from a dropdown",
  "Группа «{name}» удалена вместе со значениями — метки сняты, сами контакты на месте": "Group “{name}” deleted with its values — labels removed, contacts are intact",
  "Группа — как Reporting Tag в Zoho Books: название и список значений, у контакта одно значение": "A group works like a Reporting Tag in Zoho Books: a name and a list of values, one value per contact",
  "Группа — как Reporting Tag в Zoho Books: название измерения («Отдел», «Источник») и список значений. В карточке контакта значение выбирается из выпадающего списка, по группе — одно.": "A group works like a Reporting Tag in Zoho Books: a dimension name (“Department”, “Source”) and a list of values. In the contact card the value is picked from a dropdown, one per group.",
  "Действия с группой {name}": "Actions for group {name}",
  "Добавить значение": "Add value",
  "Значение «{name}» добавлено в группу «{group}»": "Value “{name}” added to group “{group}”",
  "Значения — по одному в строке": "Values — one per line",
  "Изменить группу": "Edit group",
  "Название группы: Отдел, Источник лида": "Group name: Department, Lead source",
  "Настройка группы": "Group settings",
  "Новая группа": "New group",
  "Простой тег — без группы": "Plain tag — no group",
  "Простые теги": "Plain tags",
  "Создать группу": "Create group",
  "Создать группу со значениями": "Create group with values",
  "Такая группа уже есть — выберите другое название": "A group with this name already exists — choose another",
  "Такое значение в группе уже есть": "This value already exists in the group",
  "Удалить группу": "Delete group",
  "Удалить группу «{name}»?": "Delete group “{name}”?",
  "Удалятся все {n} группы, метки снимутся с {count}. Сами контакты и переписка останутся.": "All {n} of the group will be deleted and removed from {count}. Contacts and conversations stay.",
  "групп": "group|groups",
  "группа · {n} · в карточке выбирается одно значение": "group · {n} · one value is picked in the contact card",
  "значений": "value|values",
  "ставятся любые, сколько угодно": "any number can be applied",
  "Enter или «Добавить» — ещё одно значение. Без значений тег останется простой меткой.": "Enter or “Add” — one more value. Without values the tag stays a plain label.",
  "Значение «{name}» удалено — метка снята с {count}": "Value “{name}” deleted — removed from {count}",
  "Значение списка": "List value",
  "Значения выпадающего списка": "Dropdown values",
  "Значения сохраняются сразу. Удаление значения снимает его с контактов.": "Values are saved immediately. Deleting a value removes it from contacts.",
  "Изменить тег и значения": "Edit tag and values",
  "Название тега: Отдел, Источник лида, VIP": "Tag name: Department, Lead source, VIP",
  "Новое значение: Furniture, Household…": "New value: Furniture, Household…",
  "Одно из значений выпадающего списка. Название, эмодзи и цвет — только у этого значения.": "One of the dropdown values. Name, emoji and colour apply to this value only.",
  "Тег «{name}» создан: {n}. В карточке контакта значение выбирается из списка": "Tag “{name}” created: {n}. In the contact card the value is picked from a dropdown",
  "Тег «{name}» стал выпадающим списком. Прежний простой тег остался на {count} — снимите его вручную": "Tag “{name}” is now a dropdown. The old plain tag is still on {count} — remove it manually",
  "Тег «{name}» удалён вместе со значениями — метки сняты, сами контакты на месте": "Tag “{name}” deleted with its values — labels removed, contacts are intact",
  "Тег без значений ставится на контакт как метка. Добавьте значения — и тег станет выпадающим списком, как Reporting Tag в Zoho Books: в карточке выбирается одно из них.": "A tag without values is applied as a label. Add values and the tag becomes a dropdown, like a Reporting Tag in Zoho Books: one value is picked in the card.",
  "Удалить значение «{name}»": "Delete value “{name}”",
  "Удалить тег со значениями": "Delete tag with values",
  "Удалятся все {n} списка, метки снимутся с {count}. Сами контакты и переписка останутся.": "All {n} of the list will be deleted and removed from {count}. Contacts and conversations stay.",
  "выпадающий список · {n} · в карточке выбирается одно": "dropdown · {n} · one is picked in the card",
  "контактах": "contact|contacts",
};
export default d;
